module.exports = __webpack_public_path__ + "static/img/Amy-Sayer.5811d6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Amy-Sayer.jpg
// module id = eYVH
// module chunks = 0